import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistedState from 'vuex-persistedstate'
import initialState from './initialState.coffee'
import actions from './actions.coffee'
import getters from './getters.coffee'
import mutations from './mutations.coffee'

Vue.use Vuex

export default new Vuex.Store(
  state: initialState()
  actions: actions
  getters: getters
  mutations: mutations
  plugins: [
    VuexPersistedState
      reducer: (state) =>
        currentState = JSON.parse(localStorage.getItem("vuex")) || {}
        Object.assign {}, state,
          updatedAt: new Date().toISOString()
          createdAt: currentState.createdAt || new Date().toISOString()
  ]
)

